import React, { useState, useCallback } from 'react';

const Tooltip = React.memo(({ children, text, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsVisible(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsVisible(false);
  }, []);

  const positions = {
    top: 'bottom-full mb-2',
    bottom: 'top-full mt-2',
    left: 'right-full mr-2',
    right: 'left-full ml-2'
  };

  const arrowPositions = {
    top: 'right-4',
    bottom: 'right-4',
    left: 'top-4',
    right: 'top-4'
  };

  return (
    <div 
      className="relative inline-block"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isVisible && (
        <div className={`absolute ${positions[position]} z-10 px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-sm dark:bg-gray-700 whitespace-nowrap`}>
          {text}
          <div className={`absolute ${position === 'top' ? 'bottom-[-5px]' : 'top-[-5px]'} ${arrowPositions[position]} w-2 h-2 rotate-45 bg-gray-900 dark:bg-gray-700`}></div>
        </div>
      )}
      {children}
    </div>
  );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
